import cn from 'classnames/bind'

import styles from './render-cell-gray-zeros.module.scss'
import { isValueZero } from './isValueZero'

const cx = cn.bind(styles)

export const renderCellGrayZeros = <
  CellData extends { columnKey: string; value?: string | Array<string> | null },
>(
  cellData?: CellData,
) => {
  if (!cellData) {
    return <span>{'Поле не задано'}</span>
  }

  const { value } = cellData

  if ('value' in cellData) {
    const zero = isValueZero(value)
    return <span className={cx(styles.root, { zero })}>{value === null ? '—' : value}</span>
  }

  return <span>{'—'}</span>
}
